import i18n from "i18next";
import {
  formattedTime,
  sinceDate,
} from "../../../components/formatted/FormattedDateAndTime";

export const formatCampaignNotificationDateTime = (date) => {
  if (!date) {
    return "-";
  }

  const language = i18n.language || navigator.language;
  const parsedDate = new Date(date);
  let datePart = parsedDate
    .toLocaleDateString(language, {
      month: "long",
      day: "numeric",
      year: "numeric",
    })
    .replace(/^\w/, (character) => character.toUpperCase());
  datePart = datePart
    .replace(/\bde\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

  const timePart = formattedTime(parsedDate);
  const connector = language.startsWith("fr") ? " à " : " at ";
  return `${datePart}${connector}${timePart}`;
};

const getTreatmentDurationDisplay = (row, t) => {
  if (!row.treatmentDate) {
    return null;
  }

  const from = row.durationFrom || row.date;
  if (!from) {
    return null;
  }

  const duration = sinceDate(from, row.treatmentDate, t);
  const noneLabel = t("time.none", "-");

  if (!duration || duration === noneLabel || duration === "-") {
    return null;
  }

  return t("campaign.historyTreatmentDuration", { duration });
};

const getRemovalDisplayFromRow = (row, t) => {
  if (row.objectRemoved === true) {
    return { main: t("Yes"), sub: null };
  }

  if (row.objectRemoved === false) {
    return {
      main: t("No"),
      sub: row.removalReason || null,
    };
  }

  return { main: "-", sub: null };
};

export const enrichHistoryRowDisplay = (row, t) => ({
  ...row,
  treatmentDurationDisplay: getTreatmentDurationDisplay(row, t),
  removalDisplay: getRemovalDisplayFromRow(row, t),
});
